<template>
  <form @submit.prevent="$emit('submit')">
    <div class="form-input">
      <label for="">First Name</label>
      <input type="text" required v-model="user.firstName"/>
    </div>
    <div class="form-input">
      <label for="">Last Name</label>
      <input type="text" required v-model="user.lastName">
    </div>
    <div class="form-input">
      <label for="">Email</label>
      <input type="text" required v-model="user.email"/>
    </div>
    <div class="form-input">
      <label for="">Confirm Email</label>
      <input type="text" required v-model="user.confirmEmail" />
    </div>
    <div class="form-input">
      <label for="">Password</label>
      <input type="password" required v-model="user.password">
    </div>
    <div class="form-input">
      <label for="">Confirm Password</label>
      <input type="password" required v-model="user.confirmPassword"/>
    </div>
    <slot></slot>
    <div class="form-input checkbox">
      <input type="checkbox" id="tos" name="scales" required>
      <label for="tos">I Agree To <a href="/terms-of-service">Terms and Conditions</a></label>
    </div>
    <v-alert type="error" :value="error">{{error}}</v-alert>
    <button type="submit" :disabled="loading">Sign Up</button>
  </form>
</template>

<script>
export default {
  props: ["user", "error", "loading"]
}
</script>

<style lang="less" scoped>
  #tos {
    margin-right: 5px;
  }

  .form-input {
    margin-top: 8px;
  }
  label {
    font-weight: 500;
    letter: 1px;
  }
  input[type=text], input[type=password] {
    border-style: solid;
    line-height: 18px;
    padding: 8px;
    width: 100%;
    border-radius: 4px;
  }

  button {
    width: 100%;
    background-color: #3898ec;
    font-weight: 600;
    color: white;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-top: 8px;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

</style>
